import { useTranslations } from '@vocab/react';
import { Notice, Text } from 'braid-design-system';
import React, { type FunctionComponent, useEffect } from 'react';

import {
  GOOD_SALARY,
  LOW_SALARY,
} from 'src/app/shared/constants/salaryFeedback';
import { ALERT_VIEWED } from 'src/app/shared/dataAnalytics/schema/constants';
import getTrackingAdapter from 'src/app/v1/dataAnalytics';
import type { SuggestedSalary } from 'src/types/salaryTypes';

import translations from './.vocab';
import { LowSalaryMessage } from './components/LowSalaryMessage';

interface Props {
  jobTitle: string;
  suggestedSalary: SuggestedSalary | null;
  type?: string;
}

export const SalaryFeedback: FunctionComponent<Props> = ({
  type,
  jobTitle,
  suggestedSalary,
}: Props) => {
  const { t } = useTranslations(translations);
  useEffect(() => {
    if (Boolean(type)) {
      const message = type === GOOD_SALARY ? 'Good' : 'Low';
      const alertEventData = [
        {
          tone: 'informational',
          type: 'banner',
          position: 'content',
          message: `${message} salary`,
          messageCode: `${message.toLowerCase()} salary`,
        },
      ];

      const eventData = {
        eventName: ALERT_VIEWED,
        alertShown: alertEventData,
      };

      getTrackingAdapter.sendLinkEvent(eventData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  if (type === GOOD_SALARY) {
    return (
      <Notice tone="positive">
        <Text>{t('salary-feedback-good-salary')}</Text>
      </Notice>
    );
  }

  if (type === LOW_SALARY) {
    return (
      <LowSalaryMessage jobTitle={jobTitle} suggestedSalary={suggestedSalary} />
    );
  }

  return null;
};
